import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import "./mobile.scss";
import { RiEyeFill, RiEyeLine, RiHeartLine } from "react-icons/ri";

const Index = (props) => (
  <>
    <div
      className={`views-favorite-card-small-wrapper d-flex flex-row align-items-center justify-content-center align-conetnt-center`}
    >
      <div className={"vfcsw__views d-flex flex-row align-items-center"}>
        <div className={"vfcsw__v-icon"}>
          <RiEyeLine />
        </div>
        <div className={"vfcsw__v-count"}>{props.views}</div>
      </div>
      <div className={"vfcsw__favorites  d-flex flex-row align-items-center"}>
        <div className={"vfcsw__f-icon"}>
          <RiHeartLine />
        </div>
        <div className={"vfcsw__f-count"}>{props.favorites}</div>
      </div>
    </div>
  </>
);

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
